<template>
  <v-col class="comments">
    <v-row no-gutters class="mx-2 mb-6 pt-1">
      <v-col cols="auto" align-self="center">
        <v-btn
          class="mr-2"
          icon
          :loading="loadingCamera"
          :disabled="loadingCamera"
          @click="takePicture = true"
          ><v-icon color="primary">mdi-camera</v-icon></v-btn
        >
      </v-col>
      <v-col align-self="center">
        <v-textarea
          hide-details
          outlined
          :placeholder="$t('comments.addComment')"
          auto-grow
          v-model="text"
          rows="1"
        ></v-textarea>
      </v-col>
      <v-col cols="auto" align-self="center">
        <v-btn
          class="ml-2"
          icon
          @click="sendMessage()"
          :loading="loadingMessage"
          :disabled="loadingMessage"
          ><v-icon color="primary">mdi-send</v-icon></v-btn
        >
      </v-col>
    </v-row>
    <transition-group name="list-complete" style="width: 100%">
      <div
        v-for="(message, index) in messages"
        :key="message.id"
        class="list-complete-item"
      >
        <v-row no-gutters class="mx-4">
          <v-col cols="auto"
            ><v-row no-gutters
              ><v-col
                ><v-img
                  :src="message.profilePictureUrl"
                  class="primary rounded-circle"
                  width="40"
                  height="40"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0 primary"
                      align="center"
                      justify="center"
                    >
                      <v-icon size="20" color="white">mdi-account</v-icon>
                    </v-row>
                  </template>
                </v-img></v-col
              ></v-row
            ><v-row no-gutters justify="center">
              <v-btn
                v-if="user.id === message.userId"
                icon
                class="error--text"
                @click="deleteMessage(message.id)"
                ><v-icon>mdi-delete-outline</v-icon></v-btn
              >
            </v-row> </v-col
          ><v-col class="pl-2" style="width: calc(100% - 50px)"
            ><v-row no-gutters class="text-caption font-weight-bold my-0 py-0">
              {{
                message.userName
                  ? message.userName
                  : $t("comments.anonymousUser")
              }}
            </v-row>
            <v-row no-gutters class="text-caption my-0 py-0">
              {{ handleISOToRelativeTime(message.createdAt.toDate()) }}
            </v-row>
            <v-row no-gutters v-if="message.text">{{ message.text }}</v-row>
            <v-row no-gutters v-if="message.imageUrl"
              ><v-img
                @click="
                  (fullScreenPictureUrl = message.imageUrl),
                    (fullScreenPicture = true)
                "
                :src="message.imageUrl"
                max-width="100%"
                max-height="150"
                class="rounded-lg shrink"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-row>
                </template> </v-img></v-row
          ></v-col>
        </v-row>
        <v-divider
          class="my-4 mx-4"
          v-if="index != messages.length - 1"
        ></v-divider>
      </div>
    </transition-group>

    <Picture v-if="takePicture" @endCapture="takePicture = false" />

    <v-img
      v-if="fullScreenPicture"
      class="shrink d-flex align-center fullScreenPicture"
      style="background-color: var(--v-primary-base)"
      :src="fullScreenPictureUrl"
      :contain="fullScreenPicture"
      @click="fullScreenPicture = !fullScreenPicture"
      ><template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </v-row> </template
    ></v-img>
  </v-col>
</template>

<script>
import { mapState, mapGetters } from "vuex";
const fb = require("../firebase.js");
import { ISOToRelativeTime } from "@/utils/dates.js";
import Picture from "./Picture.vue";

export default {
  components: {
    Picture,
  },
  data() {
    return {
      takePicture: false,
      unsubscribe: null,
      messages: [],
      text: "",
      loadingCamera: false,
      loadingMessage: false,
      fullScreenPicture: false,
      fullScreenPictureUrl: "",
    };
  },
  computed: {
    ...mapState(["user", "dialogLocation"]),
    ...mapGetters(["selectedMarker"]),
  },
  mounted() {
    this.getMessages();
  },
  methods: {
    handleISOToRelativeTime(date) {
      return ISOToRelativeTime(date);
    },
    deleteMessage(id) {
      fb.db
        .collection("comments")
        .doc(this.selectedMarker.id)
        .collection("messages")
        .doc(id)
        .delete();
    },
    sendMessage(image) {
      if (this.text === "") return;
      this.loadingMessage = true;

      let message = {
        createdAt: fb.firebase.firestore.Timestamp.now(),
        text: this.text,
        userId: this.user.id,
      };

      if (this.user.profilePictureUrl)
        message.profilePictureUrl = this.user.profilePictureUrl;
      if (this.user.name) message.userName = this.user.name;

      let self = this;
      fb.db
        .collection("comments")
        .doc(this.selectedMarker.id)
        .collection("messages")
        .add(message)
        .then(() => {
          self.loadingMessage = false;
          self.text = "";
        })
        .catch((err) => {
          self.loadingMessage = false;
          self.text = "";
        });
    },
    getMessages() {
      if (this.unsubscribe) this.unsubscribe();
      this.unsubscribe = fb.db
        .collection("comments")
        .doc(this.selectedMarker.id)
        .collection("messages")
        .orderBy("createdAt", "desc")
        .limit(10)
        .onSnapshot((snapshot) => {
          console.log("getMessages");
          this.messages = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
        });
    },
  },
  watch: {
    dialogLocation(val) {
      if (val === false) {
        this.messages = [];
      }
      if (val === true) {
        this.getMessages();
      }
    },
    // selectedMarker(val) {
    //   this.getMessages();
    // },
  },
};
</script>


<style>
.fullScreenPicture {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: 100vw !important;
  height: 100vh !important;
  animation: fadein 0.2s;
  transform-origin: 50% 50%;
  background-color: transparent !important;
  backdrop-filter: blur(6px);
}
.list-complete-item {
  transition: all 0.5s;
}
.list-complete-enter,
.list-complete-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}
.list-complete-leave-active {
  position: absolute;
  z-index: -1;
}
</style>